<template>
  <div id="app">
    <navbar></navbar>
    <router-view></router-view>
    <eva-footer></eva-footer>
    <tools></tools>
  </div>
</template>
<script>
import EvaFooter from "./components/blocks/footer.vue";
import Tools from "./components/blocks/tools.vue";
export default {
  name: "app",
  components: {
    EvaFooter,
    Tools
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// App.vue?11637dcc